<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div
    class="container-fluid pt-5 px-0"
    v-if="$store.getters.marchand || $store.getters.isAdmin"
  >
    <!--  <v-toolbar dense style="margin-bottom: 25px; padding: 0" height="90">
      <v-toolbar-title></v-toolbar-title>
      <div class="row">
        <div class="col-12 col-lg-4 col-md-4 p-0">
          <v-menu
            ref="menu"
            v-model="filter"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                style="margin-bottom: -3%"
                v-model="date"
                prepend-inner-icon="mdi-filter-variant"
                v-bind="attrs"
                readonly
                solo
                v-on="on"
              >
              </v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
        </div>
        <div class="offset-lg-4 offset-md-4 col-12 col-lg-4 col-md-4 p-0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </div>
    </v-toolbar> -->
    <filter-component
      @update:filter_url="handleFilterDataUpdate"
      @update:download="downloadCsv"
      :downloading="downloading"
    />

    <v-card elevation="0">
      <v-tabs v-model="transactions_tabs">
        <v-tab @click="getTransactionByStatus(1)">Tous</v-tab>
        <v-tab @click="getTransactionByStatus(1, 'SUCCESS')">Succès</v-tab>
        <v-tab @click="getTransactionByStatus(1, 'ERROR')">Echec</v-tab>
        <v-tab @click="getTransactionByStatus(1, 'PENDING')">En attente</v-tab>
        <v-tab @click="getTransactionByStatus(1, 'REFUNDED')">Remboursée</v-tab>
      </v-tabs>
      <v-tabs-items v-model="transactions_tabs" style="padding: 15px">
        <v-tab-item>
          <v-data-table
            :headers="headers"
            :items="transactions"
            :items-per-page="10"
            class="elevation-1"
            :loading="!transactions"
            :search="search"
          >
            <template v-slot:item._type="{ item }">
              <v-icon color="success" style="margin-right: 2px"
                >mdi-arrow-bottom-left</v-icon
              >
              <span class="text-lowercase">{{ item._type }}</span>
            </template>
            <template v-slot:item.mean="{ item }">
              <div v-if="item.mean">
                <img
                  :title="getMeanName(item)"
                  v-if="item.mean"
                  :src="item.mean._file.substr(7)"
                  style="width: 40px"
                  alt=""
                />
              </div>
              <div v-else>
                <h6>en attente</h6>
              </div>
            </template>
            <template v-slot:item._num_source="{ item }">
              <span v-if="item._num_source">
                {{ item._num_source }}
              </span>
              <span v-else> en attente </span>
            </template>
            <template v-slot:item._amount="{ item }">
              {{ formatAmount(item._amount) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._fees="{ item }">
              {{
                !isNaN(item._fees)
                  ? formatAmount(item._fees) + item.x_currency._code_alpha
                  : "---"
              }}
            </template>
            <template v-slot:item._status="{ item }">
              <v-chip
                class="text-white"
                small
                :color="getStatusColor(item._status).color"
                >{{ getStatusColor(item._status).status }}</v-chip
              >
            </template>
            <template v-slot:item._created_at="{ item }">
              {{ getDate(item._created_at) }}
            </template>
            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <router-link
                  style="text-decoration: none"
                  :to="'/transactions/details/' + item._id"
                >
                  <v-btn color="primary" class="mb-0" small>Consulter</v-btn>
                </router-link>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers_success"
            :items="transactions"
            :items-per-page="10"
            :loading="!transactions"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:item._type="{ item }">
              <v-icon color="success" small style="margin-right: 2px"
                >mdi-arrow-bottom-left</v-icon
              >
              <span class="text-lowercase">{{ item._type }}</span>
            </template>
            <template v-slot:item.mean="{ item }">
              <div v-if="item.mean">
                <img
                  :title="getMeanName(item)"
                  v-if="item.mean"
                  :src="item.mean._file.substr(7)"
                  style="width: 40px"
                  alt=""
                />
              </div>
              <div v-else>
                <h6>en attente</h6>
              </div>
            </template>
            <template v-slot:item._num_source="{ item }">
              <span v-if="item._num_source">
                {{ item._num_source }}
              </span>
              <span v-else> en attente </span>
            </template>
            <template v-slot:item._amount="{ item }">
              {{ formatAmount(item._amount) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._fees="{ item }">
              {{ formatAmount(item._fees) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._status="{ item }">
              <v-chip
                class="text-white"
                small
                :color="getStatusColor(item._status).color"
                >{{ getStatusColor(item._status).status }}</v-chip
              >
            </template>
            <template v-slot:item._created_at="{ item }">
              {{ getDate(item._created_at) }}
            </template>
            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <router-link
                  style="text-decoration: none"
                  :to="'/transactions/details/' + item._id"
                >
                  <v-btn color="primary" class="mb-0" small>Consulter</v-btn>
                </router-link>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers_failed"
            :items="transactions"
            :loading="!transactions"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item._type="{ item }">
              <v-icon color="success" small style="margin-right: 2px"
                >mdi-arrow-bottom-left</v-icon
              >
              <span class="text-lowercase">{{ item._type }}</span>
            </template>
            <template v-slot:item.mean="{ item }">
              <div v-if="item.mean">
                <img
                  :title="getMeanName(item)"
                  v-if="item.mean"
                  :src="item.mean._file.substr(7)"
                  style="width: 40px"
                  alt=""
                />
              </div>
              <div v-else>
                <h6>en attente</h6>
              </div>
            </template>
            <template v-slot:item._num_source="{ item }">
              <span v-if="item._num_source">
                {{ item._num_source }}
              </span>
              <span v-else> en attente </span>
            </template>
            <template v-slot:item._amount="{ item }">
              {{ formatAmount(item._amount) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._fees="{ item }">
              {{ formatAmount(item._fees) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._status="{ item }">
              <v-chip
                class="text-white"
                small
                :color="getStatusColor(item._status).color"
                >{{ getStatusColor(item._status).status }}</v-chip
              >
            </template>
            <template v-slot:item._created_at="{ item }">
              {{ getDate(item._created_at) }}
            </template>
            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <router-link
                  style="text-decoration: none"
                  :to="'/transactions/details/' + item._id"
                >
                  <v-btn color="primary" class="mb-0" small>Consulter</v-btn>
                </router-link>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers_pending"
            :items="transactions"
            :loading="!transactions"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item._type="{ item }">
              <v-icon color="success" small style="margin-right: 2px"
                >mdi-arrow-bottom-left</v-icon
              >
              <span class="text-lowercase">{{ item._type }}</span>
            </template>
            <template v-slot:item.mean="{ item }">
              <div v-if="item.mean">
                <img
                  :title="getMeanName(item)"
                  v-if="item.mean"
                  :src="item.mean._file.substr(7)"
                  style="width: 40px"
                  alt=""
                />
              </div>
              <div v-else>
                <h6>en attente</h6>
              </div>
            </template>
            <template v-slot:item._num_source="{ item }">
              <span v-if="item._num_source">
                {{ item._num_source }}
              </span>
              <span v-else> en attente </span>
            </template>
            <template v-slot:item._amount="{ item }">
              {{ formatAmount(item._amount) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._fees="{ item }">
              {{ formatAmount(item._fees) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._status="{ item }">
              <v-chip
                class="text-white"
                small
                :color="getStatusColor(item._status).color"
                >{{ getStatusColor(item._status).status }}</v-chip
              >
            </template>
            <template v-slot:item._created_at="{ item }">
              {{ getDate(item._created_at) }}
            </template>
            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <router-link :to="'/transactions/details/' + item._id">
                  <v-btn color="primary" class="mb-0" small>Consulter</v-btn>
                </router-link>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers_refunded"
            :items="transactions"
            :loading="!transactions"
            :search="search"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item._type="{ item }">
              <v-icon color="success" small style="margin-right: 2px"
                >mdi-arrow-bottom-left</v-icon
              >
              <span class="text-lowercase">{{ item._type }}</span>
            </template>
            <template v-slot:item.mean="{ item }">
              <div v-if="item.mean">
                <img
                  :title="getMeanName(item)"
                  v-if="item.mean"
                  :src="item.mean._file.substr(7)"
                  style="width: 40px"
                  alt=""
                />
              </div>
              <div v-else>
                <h6>en attente</h6>
              </div>
            </template>
            <template v-slot:item._num_source="{ item }">
              <span v-if="item._num_source">
                {{ item._num_source }}
              </span>
              <span v-else> en attente </span>
            </template>
            <template v-slot:item._amount="{ item }">
              {{ formatAmount(item._amount) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._fees="{ item }">
              {{ formatAmount(item._fees) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._status="{ item }">
              <v-chip
                class="text-white"
                small
                :color="getStatusColor(item._status).color"
                >{{ getStatusColor(item._status).status }}</v-chip
              >
            </template>
            <template v-slot:item._created_at="{ item }">
              {{ getDate(item._created_at) }}
            </template>
            <template v-slot:item._refunded_at="{ item }">
              {{ getDate(item._refunded_at) }}
            </template>
            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <router-link :to="'/transactions/details/' + item._id">
                  <v-btn color="primary" class="mb-0" small>Consulter</v-btn>
                </router-link>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <template>
      <div class="text-right col-12">
        <v-pagination
          elevation="0"
          v-model="page"
          :length="total_pages"
          :total-visible="7"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="getTransactionFilter"
        ></v-pagination>
      </div>
    </template>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import * as Swal from "sweetalert2";
import helpers from "../../mixins/helpers";
import GoToParams from "./globalComponents/GoToParams";
import FilterComponent from "./transactions/components/filterComponent.vue";
import JsonExcel from "vue-excel-xlsx";
export default {
  components: { GoToParams, FilterComponent, "download-excel": JsonExcel },
  label: "Transactions",
  mixins: [helpers(this)],
  data() {
    return {
      /* excelData: [],
      excelFields: {}, */
      filter: "",
      total_pages: 0,
      page: 1,
      sort_by: "_created_at",
      status: "",
      date: new Date().toISOString().substr(0, 10),
      transactions_tabs: "",
      errors: {},
      search: "",
      dialog: "",
      downloading: false,
      id: undefined,
      headers: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Référence", value: "_reference" },
        { text: "Montant", value: "_amount" },
        { text: "Frais", value: "_fees" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "", value: "action" },
      ],
      headers_success: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Référence", value: "_reference" },
        { text: "Montant", value: "_amount" },
        { text: "Frais", value: "_fees" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "", value: "action" },
      ],
      headers_failed: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Référence", value: "_reference" },
        { text: "Montant", value: "_amount" },
        { text: "Frais", value: "_fees" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "", value: "action" },
      ],
      headers_pending: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Référence", value: "_reference" },
        { text: "Montant", value: "_amount" },
        { text: "Frais", value: "_fees" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "", value: "action" },
      ],
      headers_refunded: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Référence", value: "_reference" },
        { text: "Montant", value: "_amount" },
        { text: "Frais", value: "_fees" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "Date de remboursement", value: "_refunded_at" },
        { text: "", value: "action" },
      ],
    };
  },
  computed: {
    ...mapState("payments/", [
      "transactions",
      "failed_transactions",
      "pending_transactions",
      "success_transactions",
      "refunded_transactions",
    ]),
  },
  methods: {
    downloadCsv() {
      this.downloading = true;
      let marchand = JSON.parse(sessionStorage.getItem("marchand"));
      let marchand_id = marchand && marchand._id ? marchand._id : null;
      this.$store
        .dispatch("payments/getUSerTransactionsForCsvTransactions", {
          marchand_id: marchand_id,
          sort_by: this.sort_by,
          status: this.status,
          filter: this.filter,
        })
        .then((response) => {
          this.downloadData(response.transactions);
        });
    },
    downloadData(transactions) {
      try {
        // Add BOM for UTF-8
        const BOM = "\uFEFF";

        // Prepare the data for download
        const downloadData = transactions.map((item) => {
          const row = {};
          this.headers.forEach((header) => {
            if (header.value === "_amount") {
              row[header.text] = `${this.formatAmount(item._amount)} ${
                item.x_currency._code_alpha
              }`;
            } else if (header.value === "_fees") {
              row[header.text] = !isNaN(item._fees)
                ? `${this.formatAmount(item._fees)}${
                    item.x_currency._code_alpha
                  }`
                : "---";
            } else if (header.value === "_created_at") {
              row[header.text] = this.getDate(item._created_at);
            } else if (header.value === "_status") {
              row[header.text] = this.getStatusColor(item._status).status;
            } else if (header.value !== "action" && header.value !== "mean") {
              // Escape special characters and quotes in the cell value
              row[header.text] = item[header.value];
            }
          });
          return row;
        });

        const headers = this.headers
          .filter((h) => h.value !== "action" && h.value !== "mean")
          .map((h) => h.text);

        // Properly escape and quote CSV values
        const escapeCSV = (str) => {
          if (str === null || str === undefined) return "";
          return `"${String(str).replace(/"/g, '""')}"`;
        };

        const csv =
          BOM +
          [
            headers.map(escapeCSV).join(","),
            ...downloadData.map((row) =>
              headers.map((header) => escapeCSV(row[header])).join(",")
            ),
          ].join("\n");

        let marchand = JSON.parse(sessionStorage.getItem("marchand"));
        let _company = marchand && marchand._company ? marchand._company : null;

        // Create and trigger download with UTF-8 encoding
        const blob = new Blob([csv], {
          type: "text/csv;charset=utf-8",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute(
          "download",
          `${_company}-intram-transactions-${new Date().getTime()}.csv`.toLowerCase()
        );
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        this.downloading = false;
      }
    },
    handleFilterDataUpdate({ filter_url }) {
      this.filter = filter_url;
      this.getTransactionFilter(1);
    },
    getMeanName(item) {
      return (
        item.mean._name +
        " " +
        item.mean._country._name +
        " (" +
        item.mean._type +
        ")"
      );
    },
    getTransactionFilter(page) {
      let vBox = this;
      page = page - 1;
      let marchand = JSON.parse(sessionStorage.getItem("marchand"));
      let marchand_id = marchand && marchand._id ? marchand._id : null;
      this.$store
        .dispatch("payments/getUSerTransactions", {
          marchand_id: marchand_id,
          page: page,
          sort_by: this.sort_by,
          status: this.status,
          filter: this.filter,
        })
        .then((response) => {
          vBox.page = response.page + 1;
          vBox.total_pages = response.total_pages;
        });
    },
    getTransactionByStatus(page, status) {
      this.status = status;
      this.getTransactionFilter(page);
    },
  },
  mounted() {
    let vBox = this;
    vBox.$store
      .dispatch("means_paiements/getMeans_paiements")
      .then((response) => {
        consol.log(response, "*******meand paiements********");
      });
    let marchand = JSON.parse(sessionStorage.getItem("marchand"));
    let marchand_id = marchand ? marchand._id : null;
    let page = this.page - 1;
    this.$store
      .dispatch("payments/getUSerTransactions", {
        marchand_id: marchand_id,
        page: page,
        sort_by: this.sort_by,
        status: this.status,
        filter: this.filter,
      })
      .then((response) => {
        vBox.page = response.page + 1;
        vBox.total_pages = response.total_pages;
      });
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.checkisDashboard();
  },
};
</script>

<style scoped>
.action-inputs-group {
  margin-left: 1%;
}
h2 {
  color: #29b3a6;
}
.actions-inputs {
  display: inline-block;
  margin: 15px;
}
</style>
